import { render } from "./OrderHead.vue?vue&type=template&id=694cea14"
import script from "./OrderHead.vue?vue&type=script&lang=js"
export * from "./OrderHead.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/orders.cash-mere.ch/releases/80909800/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__